/* global require, debug, withinviewport */

$(function () {
    'use strict';

    var showed = {};
    var clicked = {};
    var $ads = $('.firm-promo');

    var markAdAsShowed = function($ad) {
        var adId = $ad.data('firmPromoId');
        showed[adId] = true;

        var showUrl = $ad.data('firmPromoShowUrl');

        if (showUrl) {
            $.ajax({
               cache: false,
               url: showUrl
           });
        }
        sendToEcommerce($ad, 'show');

    };

    var markAdAsClicked = function($ad) {
        var adId = $ad.data('firmPromoId');
        clicked[adId] = true;

        var clickUrl = $ad.data('firmPromoClickUrl');

        if (clickUrl) {
            $.ajax({
               cache: false,
               url: clickUrl
           });
        }
        sendToEcommerce($ad, 'click');
    };

    var sendToEcommerce = function($ad, action) {
        var adId = $ad.data('firmPromoId');

        var promoName = $ad.data('firmPromoName');
        if (!promoName) {
            promoName = "Промо фирмы";
        }
        var promoId = promoName;
        var position = undefined;
        if ($ad.data('firmPromoPosition')) {
            position = $ad.data('firmPromoPosition');
        }

        if (typeof window.Tracker != 'undefined') {
            if (action == 'show') {
                window.Tracker.ecommerceShowPromo(promoId, promoName, 'adv_' + adId, position)
            } else if (action == 'click') {
                window.Tracker.ecommerceClickPromo(promoId, promoName, 'adv_' + adId, position);
            }
        }
    };

    if ($ads.length) {
        $(window).on('resize.FirmAdShow scroll.FirmAdShow', function() {
            $ads.each(function(){
                var $ad = $(this);
                if ($ad.isOnScreen()) {
                    var adId = $(this).data('firmPromoId');
                    if (typeof showed[adId] == 'undefined') {
                        markAdAsShowed($ad);

                        var showedCount = Object.keys(showed).length;

                        if (showedCount == $ads.length) {
                            $(window).off('.FirmAdShow');
                        }
                    }
                }
            });

        });

        $ads.on('click', function(e) {
            var $target = $(e.target);
            var $ad = $(this);
            if ($target.attr('href') || $target.hasClass('i-open-contact-overlay')) {
                var adId = $(this).data('firmPromoId');
                if (typeof clicked[adId] == 'undefined') {
                    markAdAsClicked($ad);
                }
            }
        });
    }
});